import styled from "styled-components";

export const StyledContainer = styled.div`
	position: absolute;
	width: 200px;
	height: 200px;
	background-color: var(--green50);
	z-index: 1001;
	padding: 20px;
	bottom: 0;
	transform: translate(-40%, 100%);
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	-webkit-animation: tilt-in-top-1 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)
		both;
	animation: tilt-in-top-1 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

	@-webkit-keyframes tilt-in-top-1 {
		0% {
			-webkit-transform: rotateY(30deg) translateY(-300px) skewY(-30deg);
			transform: rotateY(30deg) translateY(-300px) skewY(-30deg);
			opacity: 0;
		}
		100% {
			-webkit-transform: rotateY(0deg) translate(-40%, 100%) skewY(0deg);
			transform: rotateY(0deg) translate(-40%, 100%) skewY(0deg);
			opacity: 1;
		}
	}
	@keyframes tilt-in-top-1 {
		0% {
			-webkit-transform: rotateY(30deg) translateY(-300px) skewY(-30deg);
			transform: rotateY(30deg) translateY(-300px) skewY(-30deg);
			opacity: 0;
		}
		100% {
			-webkit-transform: rotateY(0deg) translate(-40%, 100%) skewY(0deg);
			transform: rotateY(0deg) translate(-40%, 100%) skewY(0deg);
			opacity: 1;
		}
	}

	h2 {
		font-size: 1.1rem;
		text-align: center;
		text-shadow: var(--textShadowBlack);
	}

	.menu_container {
		display: flex;
		flex-direction: row;
		gap: 10px;
		justify-content: center;
		align-items: center;

		div {
			display: flex;
			flex-direction: column;
			gap: 10px;
			justify-content: center;
			align-items: center;
			transition: 0.5s;

			&:hover {
				color: var(--blue50);
			}

			svg {
				font-size: 50px;
				-webkit-filter: drop-shadow(1px 1px 0 black)
					drop-shadow(-1px -1px 0 black);
				filter: drop-shadow(1px 1px 0 black) drop-shadow(-1px -1px 0 black);
			}

			p {
				text-shadow: var(--textShadowBlack);
			}
		}
	}
`;
